"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { MegaMenuTrigger } from "@/components/layout/navigation/MegaMenuTrigger";
import { MegaMenuPanel } from "@/components/layout/navigation/MegaMenuPanel";
import type { MegaMenuConfig } from "@/lib/navigation";
interface MegaMenuProps {
  config: MegaMenuConfig;
  isActive: boolean;
  /** The page being viewed belongs to this menu's section. */
  isCurrentSection?: boolean;
  onOpen: (id: string) => void;
  onClose: () => void;
  onMouseEnter: (id: string) => void;
  onMouseLeave: () => void;
  className?: string;
}
export function MegaMenu(t0) {
  const $ = _c(30);
  const {
    config,
    isActive,
    isCurrentSection: t1,
    onOpen,
    onClose,
    onMouseEnter,
    onMouseLeave,
    className
  } = t0;
  const isCurrentSection = t1 === undefined ? false : t1;
  const isDropdown = config.layout === "dropdown";
  const dropdownId = `mega-menu-dropdown-${config.id}`;
  let t2;
  if ($[0] !== className) {
    t2 = cn("relative flex", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== config.id || $[3] !== onMouseEnter) {
    t3 = () => onMouseEnter(config.id);
    $[2] = config.id;
    $[3] = onMouseEnter;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== config.id || $[6] !== onOpen) {
    t4 = () => onOpen(config.id);
    $[5] = config.id;
    $[6] = onOpen;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isDropdown ? dropdownId : "mega-menu-shelf";
  let t6;
  if ($[8] !== config.bottomStrip.primary.href || $[9] !== config.triggerLabel || $[10] !== isActive || $[11] !== isCurrentSection || $[12] !== onClose || $[13] !== t4 || $[14] !== t5) {
    t6 = <MegaMenuTrigger label={config.triggerLabel} href={config.bottomStrip.primary.href} isOpen={isActive} isCurrent={isCurrentSection} onOpen={t4} onNavigate={onClose} controlsId={t5} />;
    $[8] = config.bottomStrip.primary.href;
    $[9] = config.triggerLabel;
    $[10] = isActive;
    $[11] = isCurrentSection;
    $[12] = onClose;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== config || $[17] !== dropdownId || $[18] !== isActive || $[19] !== isDropdown || $[20] !== onClose || $[21] !== onMouseEnter || $[22] !== onMouseLeave) {
    t7 = isDropdown && <div id={dropdownId} className="absolute top-full left-0 mt-2 w-[420px] overflow-hidden rounded-2xl z-50 bg-surface shadow-[0_24px_48px_color-mix(in_srgb,var(--primary)_20%,transparent)]" hidden={!isActive} role="menu" onMouseEnter={() => onMouseEnter(config.id)} onMouseLeave={onMouseLeave}><MegaMenuPanel config={config} onClose={onClose} /></div>;
    $[16] = config;
    $[17] = dropdownId;
    $[18] = isActive;
    $[19] = isDropdown;
    $[20] = onClose;
    $[21] = onMouseEnter;
    $[22] = onMouseLeave;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== onMouseLeave || $[25] !== t2 || $[26] !== t3 || $[27] !== t6 || $[28] !== t7) {
    t8 = <div className={t2} onMouseEnter={t3} onMouseLeave={onMouseLeave}>{t6}{t7}</div>;
    $[24] = onMouseLeave;
    $[25] = t2;
    $[26] = t3;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
}